import { Link } from 'react-router-dom';

export default function RealEstateHero() {
  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=confident%20real%20estate%20agent%20standing%20in%20front%20of%20a%20stunning%20luxury%20home%20with%20manicured%20lawn%2C%20golden%20hour%20sunlight%20casting%20warm%20light%20across%20the%20facade%2C%20professional%20realtor%20in%20business%20attire%20smiling%2C%20upscale%20residential%20neighborhood%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20warm%20amber%20tones%2C%20no%20text%2C%20high%20contrast%2C%20photorealistic&width=1920&height=1080&seq=re-hero-bg-01&orientation=landscape"
          alt="Real estate agent in front of a luxury home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-8 text-center pt-28 pb-16">
        <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
          Built for Real Estate Agents &amp; Brokerages
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          AI Ads for Real Estate{' '}
          <span className="text-orange-400">That Actually Get Listings</span>
        </h1>

        <p className="text-lg sm:text-xl text-stone-300 max-w-2xl mx-auto mb-4 leading-relaxed">
          No marketing degree. No agency. No guesswork.{' '}
          <strong className="text-white">AdForge builds your real estate advertising</strong> in minutes —
          Facebook ads, Google ads, Instagram ads, all done by AI.
        </p>
        <p className="text-base text-stone-400 max-w-xl mx-auto mb-10">
          Just answer a few questions about your market and listings and let the AI handle the rest.
          Your first ad is free.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <a
            href="#how-it-works"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See How It Works
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          {[
            { value: '4.9★', label: 'Average Rating' },
            { value: '&lt; 3 min', label: 'To Your First Ad' },
            { value: 'Free', label: 'To Start' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-2xl font-black text-white"
                dangerouslySetInnerHTML={{ __html: stat.value }}
              />
              <div className="text-xs text-stone-400 font-medium mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
